import * as types from '../constants';
import initialState from '../initialState';

export default function reducer(state = initialState.invitation, action) {
  const { type, payload } = action;
  switch (type) {
    case types.GET_INVITATIONS:
      return {
        ...state,
        invitations: payload.invitations,
        totalCount: payload.totalCount,
      };
    case types.DELETE_INVITATION:
      return {
        ...state,
        invitations: state.invitations.filter((i) => i.id !== payload.id),
        totalCount: state.totalCount - 1,
      };
    default:
      return state;
  }
}
